import routerOptions0 from "/src/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/src/src/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}